<div class="container">
  <div class="chat-container">
    <div class="chat-menu-and-messages">
      <div *ngIf="!showArchived || !showActiveTickets">
        <div class="chat-menu" *appIfRoles="profilesElegibleToManageChats">
          <div class="items-menu" *ngIf="showOnlyMessages || showAll">
            <app-smart-link
              customClass="btn-action primary-color"
              [route]="['/channels']"
              matTooltip="Canais de atendimento"
              matTooltipClass="chat-filter-tooltip"
            >
              <span class="material-icons primary-color">list_alt</span>
            </app-smart-link>
          </div>
        </div>
      </div>

      <!-- Menu archived -->
      <div class="chat-menu" *ngIf="showArchived">

        <div class="items-menu-archive">
          <button
            class="btn-action"
            mat-icon-button
            (click)="showArchived = false"
          >
            <mat-icon svgIcon="back-arrow"></mat-icon>
          </button>
          Arquivadas
        </div>
      </div>

      <div class="chat-menu" *ngIf="showActiveTickets">
        <div class="items-menu-archive" *ngIf="showActiveTickets">
          <button
            class="btn-action"
            mat-icon-button
            (click)="showActiveTickets = false"
          >
            <mat-icon svgIcon="back-arrow"></mat-icon>
          </button>
          Atendimentos Ativos
        </div>
      </div>

      <!--  -->

      <div class="chat-messages">
        <app-chats-messages-list
          *ngIf="showOnlyMessages || showAll"
          (roomEvent)="getRoomFromChatMessages($event)"
          (userEvent)="getUserFromChatMessages($event)"
          (selectedChat)="removeInitalMessage()"
          (loadingChat)="loadingMessageList($event)"
          (existMessage)="chatStatus($event)"
          [initialMessageActive]="showInitalMessage"
          [(showArchived)]="showArchived"
          [(showActiveTickets)]="showActiveTickets"
        ></app-chats-messages-list>
      </div>
    </div>

    <div class="chat-details" *ngIf="showOnlyDetails || showAll">
      <div *ngIf="showInitalMessage" class="no-chat-details">
        <app-chat-initial
          [existMessage]="existMessage"
          [loadingList]="loadingList"
        ></app-chat-initial>
      </div>
      <div *ngIf="!showInitalMessage && itemDetails" class="messages-details">
        <div class="user-header">
          <app-user-header
            *ngIf="itemDetails?.headerDto"
            [headerDto]="itemDetails.headerDto"
            [idRoom]="itemDetails.idRoom"
            (onShowUserDetails)="openUserDetails($event)"
          >
          </app-user-header>
        </div>

        <app-chats-details
          [itemDetails]="itemDetails"
          [userDetailsVisible]="showUserDetails"
        >
        </app-chats-details>
      </div>

      <div class="user-details" *ngIf="showUserDetails && idUserDetails != ''">
        <app-user-details
          [idUserDetails]="idUserDetails"
          (onClose)="closeUserDetails()"
        >
        </app-user-details>
      </div>
    </div>
  </div>
</div>
